module.exports = __webpack_public_path__ + "static/media/bacground-welcome.9c434129.png";